import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { createQuery, IQuery, IQueryFilter, PaginatedResults } from '@utils';
import { Observable } from 'rxjs';
import { first, pluck } from 'rxjs/operators';

import { API_URL } from '../../core.tokens';
import { Enabling, EnablingType } from '../../models/enabling.model';

@Injectable()
export class EnablingCoreService {

  constructor(
    protected http: HttpClient,
    @Inject(API_URL) protected apiUrl: string
  ) { }

  getById(id: number): Observable<Enabling> {
    return this.http.get<Enabling>(`${this.apiUrl}/enabling/${id}`).pipe(first());
  }

  getByQuery(query: IQuery) {
    return this.http.post<PaginatedResults<Enabling>>(`${this.apiUrl}/enabling/query`, query).pipe(first());
  }

  getListByType(type: EnablingType, name?: string) {
    let filters: IQueryFilter[] = [{ field: 'type', op: '=', value: type }];
    if (name) {
      filters = [...filters, { field: 'name', op: 'contains', value: name }];
    }
    const query = createQuery({
      filter: {
        logic: 'and',
        filters
      },
      size: 1000
    });
    return this.getByQuery(query).pipe(pluck('results'), first());
  }

}
